<form #formulario="ngForm">
    <mat-accordion>

        <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
            <mat-expansion-panel-header>
                <mat-panel-title>Dados</mat-panel-title>
            </mat-expansion-panel-header>

            <div>

                <!-- DADOS INICIAIS -->
                <mat-toolbar class="titulopartes">Dados Iniciais</mat-toolbar>
                <div fxLayout="row" fxLayoutGap="50px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

                    <!-- FATURAS -->
                    <mat-form-field fxFlex="27%" fxFlexOffset="10px">
                        <mat-label>Fatura:</mat-label>
                        <mat-select [(ngModel)]=pagamentosFatura.idFatura name="fatura" required (selectionChange)="changeFatura()">
                            <mat-option></mat-option>
                            <mat-option *ngFor="let i of getFaturas()" [value]=i.id>
                                {{i.dataVencimento | dataSimples}} - {{i.valor | currency : 'BRL'}} {{i.tributoMovimentacao?.tributo?.id ? ' - ' + i.tributoMovimentacao?.tributo?.codigo : ''}}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="getFaturas()?.length === 0" align="start">Nenhuma fatura cadastrada para essa movimentação
                        </mat-hint>
                    </mat-form-field>

                    <!-- CONTAS BANCARIAS -->
                    <div ngModelGroup="comboContaBancariaOrigem" fxFlex="50%" fxLayoutGap="20px" fxFlexOffset="20px" class="marginCombo">
                        <combo-pesquisavel 
                                            nome="contaBancariaOrigem" 
                                            [itens]="contasBancarias" 
                                            itemDescricao="descricaoCompleta"
                                            itemId="id"
                                            label="Conta Bancária"
                                            placeholder="Escolha..."
                                            [(valor)]="pagamentosFatura.contaBancaria"
                                            (valorChange)="validarContaReembolso()"
                                            style="margin-top: 10px;">
                        </combo-pesquisavel>
                    </div> 
                </div>

                <!--
                <div fxLayout="row" fxLayoutGap="50px">
                    <mat-form-field fxFlex= "100%" fxFlexOffset="20px">
                        <input [(ngModel)]="pagamentosFatura.descricao"
                               #descricao
                               name="descricao"
                               placeholder="Descrição do pagamento"
                               matInput maxlength="200"
                               />
                        <mat-hint align="start">{{descricao.value.length}} / 200</mat-hint>       
                    </mat-form-field>
                </div>
                -->

                <div fxLayout="row" fxLayoutGap="50px">

                    <!-- VALOR -->
                    <mat-form-field fxFlexOffset="12px" fxFlex="10%">
                        <input [(ngModel)]="pagamentosFatura.valorPagamento" 
                               currencyMask name="valorPagamento"
                               placeholder="Valor:" 
                               matInput maxlength="13"
                               (blur)="validarValorPagamento()"
                               [disabled]="!pagamentosFatura.idFatura"
                               [options]="{ prefix: '', thousands: '.', decimal: ',' }" 
                               required/>
                        <span matPrefix>R$&nbsp;</span>
                    </mat-form-field>

                    <!-- DATA -->
                    <mat-form-field fxFlex="120px">
                        <input [(ngModel)]="pagamentosFatura.dataPagamento"
                               matInput 
                               (input)="onMascaraDataInput($event)" 
                               #campoPagamentoMovimento
                               name="dataPagamentoMovimento"
                               [max]="maxDataPagamento"
                               [matDatepicker]="dataPagamentoMovimento"
                               placeholder="Data" 
                               required>
                        <mat-datepicker-toggle matSuffix [for]="dataPagamentoMovimento"></mat-datepicker-toggle>
                        <mat-datepicker #dataPagamentoMovimento></mat-datepicker>
                        <mat-error *ngIf="campoPagamentoMovimento.value">A data está inválida ou superior a hoje</mat-error>
                    </mat-form-field>
                

                    <!-- FORMA DE PAGAMENTO -->
                    <mat-form-field fxFlex="250px">
                        <mat-label>Forma:</mat-label>
                        <mat-select [(ngModel)]=pagamentosFatura.formaPagamento name="formaPagamento">
                            <mat-option></mat-option>
                            <mat-option *ngFor="let i of formasPagamento.tipos" [value]=i.id>
                                {{i.descricao}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- NUMERO CHEQUE -->
                    <mat-form-field fxFlex="200px">
                        <input [(ngModel)]=pagamentosFatura.numeroDocPagamento 
                               matInput min="0" name="nrDocumento" 
                               placeholder="Número da Transação" />
                    </mat-form-field>

                
                    <mat-form-field fxFlex="110px" fxFlexOffset="20px">
                        <input [(ngModel)]="pagamentosFatura.valorMulta" 
                               currencyMask name="valorMulta"
                               placeholder="Valor da multa:" matInput maxlength="13"
                               [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
                        <span matPrefix>R$&nbsp;</span>
                    </mat-form-field>

                    <mat-form-field fxFlex="110px">
                        <input [(ngModel)]="pagamentosFatura.valorJuros" 
                               currencyMask name="valorJuros"
                               placeholder="Valor da juros:" matInput maxlength="13"
                               [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
                        <span matPrefix>R$&nbsp;</span>
                    </mat-form-field>
                    <mat-form-field fxFlex="110px">
                        <input [(ngModel)]="pagamentosFatura.valorDesconto" 
                               currencyMask name="valorDesconto"
                               placeholder="Valor do Desconto:" 
                               (blur)="validarValorPagamento()"
                               matInput maxlength="13"
                               [options]="{ prefix: '', thousands: '.', decimal: ',' }" />
                        <span matPrefix>R$&nbsp;</span>
                    </mat-form-field>
                </div>


                <mat-toolbar class="titulopartes">
                    <span>Rateio de Multas e Juros</span>
                    <span style="font-weight: 800; padding-left: 10px;" [style.color]="valorRateioSuperior && pagamentosFatura.rateioPagamento?.length > 0 ? 'red' : 'green'">(Total: {{getValorTotalRateio()}})</span>
                    <span *ngIf="valorRateioSuperior && pagamentosFatura.rateioPagamento?.length > 0" style="color: orangered; padding-left: 10px;">ATENÇÃO !!! O valor do rateio está diferente ao valor do pagamento.</span>
                </mat-toolbar>
                <div fxLayout="column" fxLayoutGap="50px" fxFlexFill>
                    <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" ngModelGroup="grupoRateioPagamento">
                        <div *ngFor="let rateio of pagamentosFatura.rateioPagamento; let index = index">
                            <fieldset style="margin-bottom: 5px;">
                                <formulario-rateio-pagamento [rateio]="rateio"
                                                             [pagamentosFatura]="pagamentosFatura" 
                                                             [index]="index"
                                                             [perfilAcesso]="perfilAcesso" 
                                                             [contasBancarias]="contasBancarias"
                                                             (onContaRateioValida)="getContaReembolsoValida($event)">
                                </formulario-rateio-pagamento>
                            </fieldset>
                        </div>
                        <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px" style="padding-top: 10px; padding-left: 20px;">
                            <div>
                                <button matTooltip="Novo" mat-mini-fab color="primary" (click)="addRateioPagamento()">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </div>
                        </div>                
                    </div>
                </div>


                <mat-toolbar class="titulopartes" style="margin-top: 10px;">
                    <span>Reembolso(s)</span>
                </mat-toolbar>
                <div fxLayout="column" fxLayoutGap="50px" fxFlexFill>
                    <div fxFlex="100%" fxLayoutGap="20px" fxFlexOffset="20px" ngModelGroup="grupoReembolso">
                        <div *ngFor="let reembolso of pagamentosFatura.reembolsos; let index = index">
                            <fieldset style="margin-bottom: 5px;">
                                <formulario-reembolso [reembolso]="reembolso"
                                                      [pagamentosFatura]="pagamentosFatura" 
                                                      [index]="index"
                                                      [perfilAcesso]="perfilAcesso" 
                                                      [contasBancarias]="contasBancarias"
                                                      (onContaReembolsoValida)="getContaReembolsoValida($event)">
                                </formulario-reembolso>
                            </fieldset>
                        </div>
                        <div *ngIf="perfilAcesso.insere" fxLayoutAlign="start center" fxLayoutGap="16px" style="padding-top: 10px; padding-left: 20px;">
                            <div>
                                <button matTooltip="Novo" mat-mini-fab color="primary" (click)="addReembolso()">
                                    <mat-icon>add</mat-icon>
                                </button>
                            </div>
                        </div>                
                    </div>
                </div>
               
            </div>

            <div *ngIf="pagamentoInvalido" 
                  style="margin-top: 20px; text-align: center; border-style: solid; border-color: red;margin-bottom: 15px;">
                <span style="color: blue">
                  {{msgValorPagamentoInvalido}}
                </span>
            </div>
           
            <div dir="rtl" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px"
                style="padding-top: 20px; padding-bottom: 10px; padding-right: 20px" fxFlexFill>

                <button mat-raised-button name="botaoLimpar" fxFlex="20%" color="primary" (click)="limpar()">
                    Limpar
                </button>

                <button *ngIf="!isAtualizar" mat-raised-button name="botaoAdicionar" 
                        [disabled]="formulario.invalid || !isContaReembolsoValida || pagamentoInvalido"
                        fxFlex="20%" color="primary" (click)="adicionar()">
                    Adicionar
                </button>

                <button *ngIf="isAtualizar" mat-raised-button name="botaoAdicionar" 
                        [disabled]="formulario.invalid || !isContaReembolsoValida || pagamentoInvalido"
                        fxFlex="20%" color="primary" (click)="atualizar()">
                    Atualizar
                </button>
            </div>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="carregarLista()"
            (closed)="openFormCadastro = true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <span>Lista ( {{movimentacoes.pagamentosFatura?.length || 0}} ) -</span>
                    <span style="font-weight: 800; padding-left: 10px;" [style.color]="valoresSuperiorValorMovimento ? 'red' : 'green'">Valor Total: {{getValorTotal() | currency: 'BRL'}}</span>      
                    <span *ngIf="valoresSuperiorValorMovimento" style="color: orangered; padding-left: 10px;">ATENÇÃO !!! A soma dos valores de pagamento está diferente do valor do movimento.</span>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource"
                style="margin-top: 20px">

                <ng-container matColumnDef="fatura">
                    <th mat-header-cell *matHeaderCellDef> Fatura </th>
                    <td mat-cell *matCellDef="let element"> 
                        {{getInfoFatura(element.idFatura).dataVencimento | dataSimples}} - {{getInfoFatura(element.idFatura).valor | currency : 'BRL'}} {{getInfoFatura(element.idFatura).tributoMovimentacao.tributo.codigo ? ' - ' + getInfoFatura(element.idFatura).tributoMovimentacao.tributo.codigo : ''}}
                    </td>
                </ng-container>

                <ng-container matColumnDef="formaPagamento">
                    <th mat-header-cell *matHeaderCellDef style="width: 20%"> Forma Pagamento </th>
                    <td mat-cell *matCellDef="let element"> {{formasPagamento.getDescricao(element.formaPagamento)}} </td>
                </ng-container>

                <ng-container matColumnDef="dataPagamento">
                    <th mat-header-cell *matHeaderCellDef> Data Pagamento </th>
                    <td mat-cell *matCellDef="let element"> {{element.dataPagamento | dataSimples}} </td>
                </ng-container>

              
                <ng-container matColumnDef="valorPagamento">
                    <th mat-header-cell *matHeaderCellDef> Valor do Pagamento </th>
                    <td mat-cell *matCellDef="let element"> {{element.valorPagamento | currency: 'BRL'}} </td>
                </ng-container>

                <ng-container matColumnDef="valorDesconto">
                    <th mat-header-cell *matHeaderCellDef> Valor Desconto </th>
                    <td mat-cell *matCellDef="let element"> {{element.valorDesconto | currency: 'BRL'}} </td>
                </ng-container>

                <ng-container matColumnDef="acoes">
                    <th mat-header-cell *matHeaderCellDef > Ações </th>
                    <td mat-cell *matCellDef="let element">
                        <button mat-button (click)="deletar(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                        <button  mat-button (click)="atualizarRegistro(element)">
                            <mat-icon>create</mat-icon>
                        </button>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <div [hidden]="!mostrarTabela">
                <mat-paginator [pageSizeOptions]="[5]" showFirstLastButtons></mat-paginator>
            </div>

            <ng-template #tabelaSemDados>
                <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 10px">
                    {{msg}}
                </div>
            </ng-template>

            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 30px">
                <div>
                    <button matTooltip="Adicionar novo pagamento" mat-fab color="primary" (click)="novo()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>


        </mat-expansion-panel>

    </mat-accordion>
</form>
